/**
 * DOM utility functions for UI interactions
 */

/**
 * Scrolls a target into view with smooth animation.
 * @param {string|Element|null|undefined} target - Element id or DOM node
 */
export const scrollIntoViewSmooth = (target) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  window.requestAnimationFrame(() => {
    const element =
      typeof target === "string" ? document.getElementById(target) : target;

    element?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
};

/**
 * Scrolls a target into view on mobile only.
 * @param {string|Element|null|undefined} target - Element id or DOM node
 */
export const scrollIntoViewOnMobile = (target) => {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined" ||
    typeof window.matchMedia !== "function" ||
    !window.matchMedia("(max-width: 767px)").matches
  ) {
    return;
  }

  scrollIntoViewSmooth(target);
};

/**
 * Sends event data to the window dataLayer for analytics
 * @param {string} event - The event name
 * @param {string|Object} service - The service or data to track
 */
export const sendToWindowDataLayer = (event, service) => {
  // Check if we're running inside an iframe
  const isInIframe = window.self !== window.top;

  if (isInIframe) {
    // If in iframe, send event data to parent window via postMessage
    const eventData = {
      type: "GTM_EVENT",
      event: event,
      clickText: service,
      timestamp: new Date().toISOString(),
      source: "dc-booking-iframe",
    };

    try {
      // Check if parent window exists and is accessible
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(eventData, "*");
      }
    } catch (error) {
      console.warn("GTM: Failed to send event to parent window:", error);
    }

    // Also try to push to local dataLayer as fallback
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        clickText: service,
        iframe_source: "dc-booking-iframe",
      });
    } catch (fallbackError) {
      console.warn("GTM: Failed to push to local dataLayer:", fallbackError);
    }
  } else {
    // If not in iframe, use normal dataLayer push
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      clickText: service,
    });
  }
};
